import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';

if (environment.production) {
  enableProdMode();
}

Promise.all([
  fetch('./assets/common/datamodel.json')
])
  .then((res) => Promise.all([res[0].json()]))
  .then((res) => {
    platformBrowserDynamic([
      { provide: 'envSettings', useValue: environment },
      { provide: 'datamodel', useValue: res[0] }
    ])
      .bootstrapModule(AppModule)
      .catch((err: any) => console.error(err));
  });
